const cfdBasisCharacteristicReport = {
  label: "CFD Basis Characteristic Report",
  name: "cfdBasisCharacteristicReport",
  parameters: [
    {
      name: "db",
      label: "Database",
      type: "select",
      defaultValue: "cfd",
      options: [
        { key: "cfd", label: "cfd" },
        { key: "cfddev", label: "cfddev" },
        { key: "cfddev_staging", label: "cfddev_staging" },
      ],
    },
    {
      name: "districtId",
      label: "District",
      type: "dbfield",
      table: "District",
      keyField: "DistrictId",
      valueField: "Name",
      sort: {
        Name: "asc",
      },
    },
  ],
};

export default cfdBasisCharacteristicReport;
